import { IRouteConfig } from '@/router/types';

export default [
  {
    path: '/selection-manage',
    name: 'SelectionManage',
    component: () => import('@/layouts/main/index.vue'),
    meta: {
      title: '选款管理'
    },
    children: [
      {
        path: 'selection-list',
        name: 'SelectionManageSelectionList',
        component: () => import('./selection-list/views/list/index.vue'),
        meta: {
          title: '选款列表',
          auth: true,
        },
      },
      {
        path: 'aigc-selection-list',
        name: 'AigcSelectionManageSelectionList',
        component: () => import('./aigc-selection-list/views/list/index.vue'),
        meta: {
          title: 'AIGC选款列表',
          auth: true,
        },
      },
    ],
  }
] as IRouteConfig[];
